import { useTranslation } from "react-i18next";
import { showWarning } from "../../services/ModalService";

export default function UploadBase64({ accept, afterLoadCallback, multiple }) {
  const { t } = useTranslation();
  const MAX_SIZE = 32000000;

  function onChange({ target }) {
    if (target.files) {
      if (getRequestSize(target.files) > MAX_SIZE) {
        showWarning(
          t("the total size, is bigger than the maximum allowed 32Mb")
        );

        return;
      }
      if (checkForInvalidMimetypes(target.files)) {
        showWarning(t("Invalid file type"));

        return;
      }

      let listFilebase64 = [];
      let numberOfFiles = target.files.length;
      [].forEach.call(target.files, (file) => {
        numberOfFiles--;
        const reader = new FileReader();
        reader.onload = () => {
          let fileBase64 = {
            base64: reader.result.split(",")[1],
            fileName: file.name,
            mimeType: file.type
          };
          listFilebase64.push(fileBase64);
          if (numberOfFiles === 0) afterLoadCallback(listFilebase64);
        };
        reader.readAsDataURL(file);
      });
    }
  }

  function getRequestSize(files) {
    let size = 0;
    for (let file of files) size += file.size;
    return size;
  }

  function checkForInvalidMimetypes(files) {
    for (let file of files) {
      if (!accept.includes(file.type)) return true;
    }
    return false;
  }

  return (
    <>
      <section className="upload-area">
        <label className="upload-label">{t("Documents")}</label>
        <h1>{t("Upload your documents")}</h1>
        <input
          className="upload-inputfield"
          type="file"
          id="file"
          onChange={onChange}
          accept={accept}
          multiple={multiple}
        />
      </section>
    </>
  );
}
